<template>
  <b-card
    v-if="bannerContent"
    no-body
  >
    <div class="p-0">
      <img
        src="/public/img/family.png"
        width="100%"
        alt=""
        srcset=""
      >
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue';

export default {
  components: {
    BCard,
  },
  props: {
    bannerContent: {
      type: Object,
      default: Object,
    },
    showIcon: {
      type: String,
      default: 'FileTextIcon',
    },
  },
}
</script>
